import { Injectable, signal } from '@angular/core';

export type ToastType = 'info' | 'success' | 'error' | 'warning';

export interface Toast {
  type: ToastType;
  title?: string;
  footnote?: string;
  message: string;
  durationMs: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private _toast = signal<Toast | null>(null);
  readonly toast = this._toast.asReadonly();

  private dismissTimeoutId?: ReturnType<typeof setTimeout>;
  private replaceTimeoutId?: ReturnType<typeof setTimeout>;

  raise(type: ToastType, message: string, title?: string, footnote?: string, durationMs = 5000): void {
    clearTimeout(this.dismissTimeoutId);
    clearTimeout(this.replaceTimeoutId);

    // Force null first so @if destroys and recreates the element, restarting the CSS animation
    this._toast.set(null);

    this.replaceTimeoutId = setTimeout(() => {
      this._toast.set({ type, title, footnote, message, durationMs });
      this.dismissTimeoutId = setTimeout(() => this._toast.set(null), durationMs);
    }, 0);
  }

  dismiss(): void {
    clearTimeout(this.dismissTimeoutId);
    clearTimeout(this.replaceTimeoutId);
    this._toast.set(null);
  }
}
